import { Icon } from "@chakra-ui/react";

export const CircleMinusIcon = (props: any) => {

return (<Icon {...props}>
<path d="M9 0a9 9 0 110 18A9 9 0 019 0zm0 1a8 8 0 100 16A8 8 0 009 1zM5 8.5h8a.5.5 0 110 1H5a.5.5 0 010-1z" fill="currentColor"></path>
</Icon>);

}